import {gql} from "@apollo/client";

export const getPlans = gql`
  query getPlans {
    plans {
      id, name, features, price, active
      usersLimit
      menusLimit
    }
  }
`

export const getActivePlans = gql`
  query getActivePlans {
    activePlans {
      id, name, features, price, active
      usersLimit
      menusLimit
    }
  }
`
